import React from 'react';
interface SectionHeadingProps {
  index: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
}
export function SectionHeading({
  index,
  title,
  description,
  align = 'left',
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={['max-w-3xl', align === 'center' ? 'mx-auto text-center' : ''].join(' ')} data-id="element-193" data-mp="3k186jv9k38ee">
      <div className={['flex items-center gap-3 text-[11px] font-semibold uppercase tracking-overline', align === 'center' ? 'justify-center' : '', isDark ? 'text-bronze-400' : 'text-bronze-600'].join(' ')} data-id="element-194" data-mp="bmgf4ot2sjy2">
        <span data-id="element-195" data-mp="6slof1f1z4ph">{index}</span>
        <span aria-hidden="true" className={isDark ? 'h-px w-10 bg-bronze/50' : 'h-px w-10 bg-bronze/60'} data-id="element-196" data-mp="6ru3qlmzurdz" />
      </div>
      <h2 className={['mt-4 font-serif text-3xl leading-tight sm:text-4xl', isDark ? 'text-white' : 'text-navy'].join(' ')} data-id="element-197" data-mp="zahiljbeda6m">
        {title}
      </h2>
      {description ? <p className={['mt-4 text-base leading-relaxed', isDark ? 'text-steel-300' : 'text-steel-400'].join(' ')} data-id="element-198" data-mp="1obxf3683m96h">
          {description}
        </p> : null}
    </div>;
}